import { render, staticRenderFns } from "./Turnos.vue?vue&type=template&id=01cb307a&scoped=true&lang=pug"
import script from "./Turnos.vue?vue&type=script&lang=js"
export * from "./Turnos.vue?vue&type=script&lang=js"
import style0 from "./Turnos.vue?vue&type=style&index=0&id=01cb307a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cb307a",
  null
  
)

export default component.exports